import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-components';
import AudiLogo from './AudiLogo';

type MapMarkerContainerProps = {
  isMobileScreen: boolean;
};

export const MapMarkerContainer = styled.div.attrs((props: { 'data-test-id': string }) => ({
  className: 'map-marker__container',
  'data-test-id': props['data-test-id'] ? props['data-test-id'] : 'map-marker-container',
}))<MapMarkerContainerProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
  cursor: pointer;
  width: ${({ isMobileScreen }) => `${isMobileScreen ? 44 : 48}px`};
  height: ${({ isMobileScreen }) => `${isMobileScreen ? 44 : 48}px`};
`;

const getMapMarkerContentBackgroundColor = (isSelected?: boolean, isHovered?: boolean): string => {
  if (isSelected) {
    return '#f50537';
  }

  if (isHovered) {
    return '#4c4c4c';
  }

  return 'black';
};

type MapMarkerContentProps = {
  isSelected?: boolean;
  isHovered?: boolean;
};

export const MapMarkerContent = styled.div.attrs(({ isHovered }: MapMarkerContentProps) => ({
  className: `map-marker__icon-container${isHovered ? ' map-marker-icon-container_hovered' : ''}`,
  'data-test-id': 'map-marker-icon-container',
}))<MapMarkerContentProps>`
  width: 100%;
  height: 80%;
  background: ${({ isSelected, isHovered }) =>
    getMapMarkerContentBackgroundColor(isSelected, isHovered)};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  ::after {
    content: '';
    width: 12px;
    height: 12px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    bottom: -6px;
    background: inherit;
    z-index: -1;
  }
`;

export const MapMarkerNumOfDealers = styled(Text).attrs({
  'data-test-id': 'cluster-marker__num-dealers',
})`
  span {
    color: white;
    font-weight: normal;
  }
`;

export const MapMarkerDealerIconContainer = styled.div`
  width: 80%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MapMarkerDefaultIcon = styled(AudiLogo)`
  height: 100%;
  width: 80%;
  display: block;
`;
